import Home from "@/components/Home";
import Contact from "@/components/Contact/Contact";
import Price from "@/components/Price/Price";

export const routes = [
    {path: "/", component: Home, name: "Home"},
    {path: "/contact", component: Contact, name: "Contact"},
    {path: "/price", component: Price, name: "Price"},
];
